<template>
  <div>

    <b-row class="mt-4 mb-2 border-bottom">
      <b-col>
        <h5>{{ trans('breakdown') }}</h5>
      </b-col>
      <b-col cols="auto" class="text-right">
        <small class="badge badge-success">{{ trans('filled') }}</small>
        <small class="badge badge-danger">{{ trans('remaining') }}</small>
      </b-col>
    </b-row>

    <b-row v-for="stat in stats" v-bind:data="stat" v-bind:key="stat.uid" class="mb-2 strong-on-hover">
      <b-col :class="padClass(stat)">
        <small>
          <span class="text-muted">{{ stat.type == 'category' ? '' : '⤷' }}</span>
          {{ stat.name }}
        </small>
      </b-col>
      <b-col :class="padClass(stat)" >
        <div :title="title(stat)" data-toggle="tooltip" data-placement="bottom">
          <b-progress :max="stat.spots || stat.filled + stat.remaining" show-value height="1.5rem">
            <b-progress-bar :value="stat.filled" variant="success" />
            <b-progress-bar :value="stat.remaining" variant="danger" />
          </b-progress>
        </div>
      </b-col>
    </b-row>

  </div>
</template>

<style>
.strong-on-hover:hover small,
.strong-on-hover:hover .progress-bar {
  font-weight: bold;
}
</style>

<script>
export default {
  props: ['stats'],
  data() {
    return {
      trans: trans,
      numeral: numeral,
    }
  },
  methods: {
    padClass(stat) {
      if (stat.type == 'subcategory') return 'ml-2'
      if (stat.type == 'activity') return 'ml-4'
      return ''
    },
    title(stat) {
      return (stat.unlimited ? trans('type_has_unlimied_spots') : trans('type_has_num_spots'))
        .replace(':type', trans(stat.type))
        .replace(':name', stat.name)
        .replace(':count', stat.spots)
    }
  },
  mounted() {
    $(this.$el).find('[data-toggle="tooltip"]').tooltip()
  },
}
</script>